module.exports = __webpack_public_path__ + "static/images/styles/images/building-card/building-card-bg-50.153b9c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./styles/images/building-card/building-card-bg-50.jpg
// module id = 3494
// module chunks = 11